import { render, staticRenderFns } from "./BlockTestimonies.vue?vue&type=template&id=2cb2f3b6&"
import script from "./BlockTestimonies.vue?vue&type=script&lang=js&"
export * from "./BlockTestimonies.vue?vue&type=script&lang=js&"
import style0 from "./BlockTestimonies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports